var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{attrs:{"bordered":"","fields":_vm.fields,"items":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }